import Button from 'ui/Button';
import Dialog from 'ui/Dialog';
import Icon from 'ui/Icon';
import { Flex, HStack } from 'ui/Layout';
import Tooltip from 'ui/Tooltip';
import { Text } from 'ui/Typography';

import {
  downloadImageFormatOptions,
  downloadScalePNGOptions,
} from '../../constants';
import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { useCurrentUser } from '../../utils/user';
import { FormSelect } from '../SankeyForm';
import { useImageDownloader } from './utils';

type Props = {
  open: boolean;
  onClose: () => void;
};

// TODO: Rename to DownloadDiagramDialog and integrate with opener trigger
const DownloadDiagramModal: React.FC<Props> = ({ open, onClose }) => {
  const { form } = useSankeyFormContext();
  const { user } = useCurrentUser();

  const { isDownloading, downloadImage } = useImageDownloader(form, onClose);
  const downloadImageFormat = form.watch('download_image_format');

  const notSubscribedTooltip = !user
    ? 'Please subscribe to choose a different image format'
    : '';

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    downloadImage();
  };

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Content>
        <form onSubmit={handleSubmit}>
          <Dialog.Header>
            <Icon fontSize="md" icon="floppy-disk-regular" mr={2} /> Download
            diagram
          </Dialog.Header>
          <Dialog.Body>
            <Flex alignItems="stretch" direction="column" gap={2}>
              <HStack justifyContent="space-between">
                <Text>
                  Image format
                  {notSubscribedTooltip && (
                    <Tooltip content={notSubscribedTooltip}>
                      <Icon
                        color="gray.600"
                        cursor="help"
                        icon="info-circle"
                        ml={2}
                      />
                    </Tooltip>
                  )}
                </Text>
                <Tooltip content={notSubscribedTooltip} asChild={false}>
                  <FormSelect
                    field="download_image_format"
                    options={downloadImageFormatOptions}
                    disabled={!!notSubscribedTooltip}
                    size="sm"
                    w="200px"
                  />
                </Tooltip>
              </HStack>
              {downloadImageFormat === 'png' && (
                <HStack justifyContent="space-between">
                  <Text>Download resolution</Text>
                  <FormSelect
                    field="download_scale_png"
                    options={downloadScalePNGOptions}
                    size="sm"
                    w="200px"
                  />
                </HStack>
              )}
            </Flex>
          </Dialog.Body>
          <Dialog.Footer>
            <Button
              type="submit"
              variant="primary-solid"
              loading={isDownloading}
            >
              Download {downloadImageFormat === 'png' ? 'PNG' : 'SVG'}
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DownloadDiagramModal;
